import { hasFlag } from 'legacy/lut/components/widgets/public/partner360/reports/managerDashboard/helpers/hasFlag'

import { IWelcomeFlowPartner, WelcomeFlowBitClasses } from '../api'

export const TOP_OPH = [WelcomeFlowBitClasses.TopMarketOph, WelcomeFlowBitClasses.TopWwOph]
export const TOP_BPS = [WelcomeFlowBitClasses.TopMarketBps, WelcomeFlowBitClasses.TopWwBps]
export const PRINT_SERVICES = [
  WelcomeFlowBitClasses.StrategicPrintServices,
  WelcomeFlowBitClasses.StrategicMps,
  WelcomeFlowBitClasses.StrategicPsServices,
]
export const OTHERS = [WelcomeFlowBitClasses.Other]

export const groupByTops = (partners: IWelcomeFlowPartner[], groups: WelcomeFlowBitClasses[]) => {
  return groups
    .flatMap((flag) => partners.filter((p) => hasFlag(flag, p.BitClass)))
    .filter(
      (it, index, source) => source.findIndex((it2) => it2.PartnerId === it.PartnerId) === index
    )
}
